mutation TripCopy(
  $input: TripCopyInput!
) {
  tripCopy(input: $input) {
  trip{
    id
    _rowTimestamp
  }
  }
}
